import { render, staticRenderFns } from "./Catogories.vue?vue&type=template&id=656b8b6a&scoped=true&"
import script from "./Catogories.vue?vue&type=script&setup=true&lang=js&"
export * from "./Catogories.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656b8b6a",
  null
  
)

export default component.exports